import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { Col, Row } from '../grid';
import Error from '../icons/internals/Error';
import CheckCircle from '../icons/internals/CheckCircle';
import Rolling from '../icons/internals/Rolling';

const defaultPrefixCls = 'ne-easy-form-field';
const defaultErrorIcon = <Error className={`${defaultPrefixCls}-status-icon ne-icon-error`} />;
const defaultLoadingIcon = (
  <Rolling className={`${defaultPrefixCls}-status-icon ne-icon-loading`} />
);
const defaultSuccessIcon = (
  <CheckCircle className={`${defaultPrefixCls}-status-icon ne-icon-success`} />
);

/**
 *
 * @ignore
 */
function fieldRender({
  children,
  id,
  error,
  validating,
  label,
  size,
  style,
  prefixCls = defaultPrefixCls,
  dataBindProps,
  helperText,
  className,
  inline,
  labelLayout = {
    size: 10,
  },
  contentLayout = {
    size: 8,
  },
  nativeStatusIcon,
  errorIcon = defaultErrorIcon,
  validatingIcon = defaultLoadingIcon,
  successIcon = defaultSuccessIcon,
}) {
  /* eslint-disable */
  let input;
  try {
    React.Children.only(children);
    input = cloneElement(
      children,
      Object.assign(
        {
          id,
          ...dataBindProps,
          status,
          size,
        },
        nativeStatusIcon
          ? {
              showStatusIcon: true,
              errorIcon,
              loadingIcon: validatingIcon,
              successIcon,
            }
          : null,
      ),
    );
  } catch {
    console.warn('Field must have one valid child. E.g input, Select');
    input = children;
  }
  const status = validating ? 'loading' : error && error.length > 0 ? 'error' : null;
  const Label = label ? 'label' : 'span';
  const classes = classNames(prefixCls, className, {
    [`${prefixCls}-${size}`]: size,
    [`${prefixCls}-${status}`]: status,
    [`${prefixCls}-inline`]: inline,
  });

  const statusIcon = {
    error: errorIcon,
    loading: validatingIcon,
    success: successIcon,
  };
  const finalLabelLayout = inline ? { size: 8 } : labelLayout;
  const finalContentLayout = inline ? { size: 16 } : contentLayout;
  return (
    <Row className={classes} style={style}>
      <Col {...finalLabelLayout} className={`${prefixCls}-col ${prefixCls}-label-container`}>
        <Label htmlFor={id}>{label}</Label>
      </Col>
      <Col {...finalContentLayout} className={`${prefixCls}-content-container`}>
        {input}
        <div className={`${prefixCls}-status`}>{nativeStatusIcon ? null : statusIcon[status]}</div>
        <span className={`${prefixCls}-helper-text`}>
          {status === 'error' && error ? error[0] : helperText}
        </span>
      </Col>
    </Row>
  );
  /* eslint-enable */
}

export default fieldRender;



// WEBPACK FOOTER //
// ./src/easyForm/fieldRender.js